const capabilityItems = [
  {
    num: '01',
    title: 'Treaty Reinsurance',
    copy: 'Proportional and non-proportional programmes structured around portfolio performance, capital needs and underwriting strategy.',
  },
  {
    num: '02',
    title: 'Facultative Reinsurance',
    copy: 'Dedicated capacity and carefully negotiated terms for large, complex, specialised or unusual individual risks.',
  },
  {
    num: '03',
    title: 'Risk & Portfolio Advisory',
    copy: 'Portfolio analysis, catastrophe exposure assessment, large-risk inspections and technical reinsurance audits.',
  },
  {
    num: '04',
    title: 'Claims Consultancy',
    copy: 'Coordination with insurers, surveyors and reinsurers to support the efficient handling of large and complex claims.',
  },
]

function Capabilities() {
  return (
    <section className="capabilities" id="capabilities">
      <div className="capability-layout">
        <div className="section-head capability-intro">
          <div className="eyebrow">Our capabilities</div>
          <h2>
            <span className="intro-title-line">Technical depth.</span>
            <span className="intro-title-line">Practical execution.</span>
          </h2>
          <p>From portfolio analysis to placement and claims, our capabilities are designed around the real operating needs of insurers and reinsurers.</p>
        </div>
        <div className="cap-list">
          {capabilityItems.map((item) => (
            <article key={item.num} className="cap" tabIndex="0" data-label={item.num}>
              <span className="cap-num">{item.num}</span>
              <h3>{item.title}</h3>
              <p>{item.copy}</p>
              <span className="cap-arrow">→</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Capabilities
